import { FacilityInfrastructureModel } from "./facility-infrastructure.model"
import { FacilityTranslatableDetailsModel } from "./facility-translatable-details.model"
import { IotGateModel } from "./iot-gate.model"
import { TariffModel } from "./tariff.model"

export class FacilityModel {
  id!: string
  name!: string
  capacity!: number
  free!: number
  street!: string
  streetNumber!: string
  postalCode!: string
  city!: string
  longitude!: string
  latitude!: string
  thumbnail!: Media
  map!: Media
  carousel!: Media[]
  priceHourly!: number
  priceDaily!: number
  translatableDetails!: FacilityTranslatableDetailsModel[]
  distance!: number
  height!: number
  numberOfGates!: number
  keycode!: number
  internalComments!: string
  facilityInfrastructures!: FacilityInfrastructureModel[]
  tariffs!: TariffModel[]
  gates?: IotGateModel[]

  get occupied(): number {
    return this.capacity - this.free
  }
}
export interface Media {
  id: number
  path: string
}
